import { configureStore } from '@reduxjs/toolkit'

import authReducer from './slices/authSlice'
import notificationReducer from './slices/notificationSlice'
import navigationReducer from './slices/navigationSlice'
import mylistReducer from './slices/mylistSlice'

export const store = configureStore({
	reducer: {
		auth: authReducer,
		notifications: notificationReducer,
		navigation: navigationReducer,
		mylist: mylistReducer
	},
	devTools: process.env.NODE_ENV !== 'production'
})
